import React from 'react';
import { Wallet, AlertTriangle } from 'lucide-react';

export default function DisconnectWalletModal({
    showDisconnectWalletModal,
    setShowDisconnectWalletModal,
    walletAddress,
    solBalance,
    isLoadingSolBalance,
    solBalanceError,
    selectedNetworkData,
    disconnectWallet
}) {
    return (
        showDisconnectWalletModal && (
            <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[150] flex items-center justify-center overflow-y-auto overflow-x-hidden p-3 sm:p-4">
                <div className="mx-auto max-h-[calc(100dvh-2rem)] w-full min-w-0 max-w-md overflow-y-auto rounded-2xl border border-gray-700 bg-gray-800 p-4 sm:p-6">
                    <div className="flex items-center space-x-3 mb-4">
                        <div className="w-12 h-12 bg-orange-500/20 rounded-xl flex items-center justify-center">
                            <Wallet className="w-6 h-6 text-orange-400" />
                        </div>
                        <div>
                            <h3 className="text-lg font-semibold text-white">Disconnect Wallet</h3>
                            <p className="text-gray-400 text-sm">Are you sure you want to disconnect your wallet?</p>
                        </div>
                    </div>

                    <div className="mb-6">
                        <p className="text-gray-300 mb-3">
                            Your wallet will be disconnected from the application. You can reconnect it anytime.
                        </p>
                        <div className="min-w-0 max-w-full overflow-hidden rounded-lg bg-gray-700/50 p-3">
                            <div className="text-gray-400 text-sm mb-1">Connected Wallet:</div>
                            <div className="break-all font-mono text-xs leading-snug text-white sm:text-sm">
                                {walletAddress}
                            </div>
                            <div className="flex items-center justify-between mt-1">
                                <div className="text-gray-300 text-sm">
                                    {solBalanceError ? (
                                        <div className="flex items-center space-x-1 text-red-400">
                                            <AlertTriangle className="w-3 h-3" />
                                            <span className="text-sm">Error</span>
                                        </div>
                                    ) : (
                                        `${solBalance.toFixed(6)} ${selectedNetworkData?.symbol || 'SOL'}`
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex space-x-3">
                        <button
                            onClick={() => setShowDisconnectWalletModal(false)}
                            className="flex-1 py-2 bg-gray-700 hover:bg-gray-600 text-gray-300 rounded-lg font-medium transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => {
                                disconnectWallet();
                                setShowDisconnectWalletModal(false);
                            }}
                            className="flex-1 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-medium transition-colors"
                        >
                            Disconnect
                        </button>
                    </div>
                </div>
            </div>
        )
    );
} 